module.exports = __webpack_public_path__ + "img/ico_account_info.fd929df7.svg";